export const SET_CARD_VALIDATION_ERROR = 'SET_CARD_VALIDATION_ERROR';

export const setCardValidationError = (payload) => ({
  type: SET_CARD_VALIDATION_ERROR,
  payload,
});
